module.exports = __webpack_public_path__ + "static/media/No Hidden cost.8e302a98.svg";